import { Table, Tag, Spin } from "antd";
import dayjs from "dayjs";
import Header from "../_shared/components/Header";
import { useGetAuditLogQuery } from "../../../redux/api/scheduling";
import { formatDateTime } from "../_shared/utils/dateUtils";

const ACTION_COLORS: Record<string, string> = { create: "green", update: "blue", delete: "red" };

export default function AuditLogPage() {
  const { data, isLoading } = useGetAuditLogQuery({});
  const logs = data?.results || data || [];

  const columns = [
    {
      title: "Timestamp",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (v: string) => formatDateTime(v, "MM/DD/YYYY HH:mm:ss"),
    },
    { title: "User", dataIndex: "user_email", key: "user_email" },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (v: string) => <Tag color={ACTION_COLORS[v]}>{v.toUpperCase()}</Tag>,
    },
    { title: "Model", dataIndex: "model_name", key: "model_name" },
    { title: "Object", dataIndex: "object_repr", key: "object_repr" },
  ];

  return (
    <div className="w-full p-4">
      <Header title="Audit Log" />
      {isLoading ? (
        <Spin size="large" className="mt-10 mx-auto block" />
      ) : (
        <Table dataSource={logs} columns={columns} rowKey="id" size="small" />
      )}
    </div>
  );
}
